<template>
    <div v-if="!!$store.state.cart"
         id="orderForm"
         class="form order-form">
        <template v-if="!!success">
            <p>
                <b v-html="success"></b>
            </p>
        </template>
        <template v-else>
            <form @submit="checkForm"
                  method="post">
                <template v-if="errors.length">
                    <p><b>{{trans('formError')}}</b></p>
                </template>
                <template v-if="responseError">
                    <p><b>{{responseError}}</b></p>
                </template>
                <template v-if="!$store.state.user">
                    <p><sup>*</sup> {{trans('label_required')}}</p>
                    <div>
                        <label for="companyName">{{trans('label_companyName')}}<sup>*</sup></label>
                        <input id="companyName"
                               v-model="contact.companyName"
                               type="text"
                               name="name"
                               required>
                        <p v-if="errors.companyName"
                           class="error">
                            {{errors.companyName}}
                        </p>
                    </div>
                    <div>
                        <label for="contactName">{{trans('label_contact')}}<sup>*</sup></label>
                        <input id="contactName"
                               v-model="contact.contactName"
                               type="text"
                               name="contactName"
                               required>
                        <p v-if="errors.contactName"
                           class="error">
                            {{errors.contactName}}
                        </p>
                    </div>
                    <div>
                        <label for="contactEmail">{{trans('label_email')}}<sup>*</sup></label>
                        <input id="contactEmail"
                               v-model="contact.contactEmail"
                               type="email"
                               name="email"
                               required>
                        <p v-if="errors.contactEmail"
                           class="error">
                            {{errors.contactEmail}}
                        </p>
                    </div>
                    <div>
                        <label for="contactAddress">{{trans('label_address')}}</label>
                        <input id="contactAddress"
                               v-model="contact.contactAddress"
                               type="text"
                               name="address">
                    </div>
                    <div>
                        <label for="contactZipcode">{{trans('label_zipcode')}}</label>
                        <input id="contactZipcode"
                               v-model="contact.contactZipcode"
                               type="text"
                               name="zipcode">
                    </div>
                    <div>
                        <label for="contactCity">{{trans('label_city')}}</label>
                        <input id="contactCity"
                               v-model="contact.contactCity"
                               type="text"
                               name="city">
                    </div>
                    <div>
                        <label for="contactCountry">{{trans('label_country')}}</label>
                        <input id="contactCountry"
                               v-model="contact.contactCountry"
                               type="text"
                               name="country">
                    </div>
                    <div>
                        <label for="contactPhone">{{trans('label_phone')}}</label>
                        <input id="contactPhone"
                               v-model="contact.contactPhone"
                               type="text"
                               name="phone">
                    </div>
                </template>
                <template v-if="$store.state.cart">
                    <div class="form-header"><label>{{trans('label_request')}}<sup>*</sup></label></div>
                    <div>
                        <label for="orderRequest">{{trans('label_order')}}</label>
                        <input id="orderRequest"
                               v-model="order.type"
                               type="radio"
                               value="Bestelling"
                               required>
                        <label for="orderQuotation">{{trans('label_quotation')}}</label>
                        <input id="orderQuotation"
                               v-model="order.type"
                               type="radio"
                               value="Offerte">
                        <p v-if="errors.orderType"
                           class="error">
                            {{errors.orderType}}
                        </p>
                    </div>
                    <div class="form-header"><label>{{trans('label_delivery')}}<sup>*</sup></label></div>
                    <div>
                        <label for="orderOnCall">{{trans('label_at_request')}}</label>
                        <input id="orderOnCall"
                               type="radio"
                               v-model="order.date"
                               value="Op afroep"
                               required>
                        <label for="orderDirect">{{trans('label_direct')}}</label>
                        <input id="orderDirect"
                               type="radio"
                               v-model="order.date"
                               value="Direct">
                        <p v-if="errors.orderDate"
                           class="error">
                            {{errors.orderDate}}
                        </p>
                    </div>
                    <div v-if="order.date === 'Op afroep'"
                         class="delivery-week clear">
                        <label for="deliveryWeek">{{trans('label_delivery_week')}}<sup>*</sup></label>
                        <input id="deliveryWeek"
                               v-model="order.week"
                               type="text"
                               maxlength="2">
                    </div>
                    <p v-if="errors.orderWeek"
                       class="error">
                        {{errors.orderWeek}}
                    </p>
                    <div>
                        <label for="orderNote">{{trans('label_notes')}}</label>
                        <textarea id="orderNote"
                                  v-model="order.note"
                                  name="orderNote">
                    </textarea>
                    </div>
                    <a class="btn btn-primary btn-submit"
                       @click="checkForm"
                       :disabled="isProcessing">
                        {{!isProcessing ? trans('label_submit') : trans('processing')}}
                    </a>
                </template>
            </form>
        </template>
    </div>
</template>

<script>
    import {HTTP} from "../http-common";
    import Qs from 'qs';
    import {config} from "../config";

    export default {
        name: "OrderForm",
        data() {
            return {
                errors: {},
                success: false,
                isProcessing: false,
                responseError: false,
                contact: {
                    companyName: null,
                    contactName: null,
                    contactEmail: null,
                    contactAddress: null,
                    contactZipcode: null,
                    contactCity: null,
                    contactCountry: null,
                    contactPhone: null,
                },
                order: {
                    note: null,
                    type: null,
                    date: null,
                    week: null,
                },
            }
        },
        methods: {
            checkForm: function (e) {
                e.preventDefault();
                this.errors = [];
                let submit = true;
                if (!this.$store.state.user && !this.contact.companyName) {
                    this.errors.companyName = this.trans('error_companyName');
                    submit = false;
                }
                if (!this.$store.state.user && !this.contact.contactName) {
                    this.errors.contactName = this.trans('error_contactName');
                    submit = false;
                }
                if (!this.$store.state.user && !this.contact.contactEmail) {
                    this.errors.contactEmail = this.trans('error_email');
                    submit = false;
                } else if (!this.$store.state.user && !this.validEmail(this.contact.contactEmail)) {
                    this.errors.contactEmail = this.contact.contactEmail + ' is geen geldig email adres';
                    submit = false;
                }
                if (this.order.type === null) {
                    this.errors.orderType = this.trans('error_request');
                    submit = false;
                }
                if (this.order.date === null) {
                    this.errors.orderDate = this.trans('error_delivery');
                    submit = false;
                }
                if (this.order.date === 'Op afroep' && this.order.week === null) {
                    this.errors.orderWeek = this.trans('error_delivery_week');
                    submit = false;
                }
                if (this.order.date === 'Direct') {
                    this.order.week = null;
                }
                if (submit) {
                    this.submitCart();
                }
            },
            validEmail: function (email) {
                //eslint-disable-next-line
                return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
            },
            async submitCart() {
                const self = this;
                this.isProcessing = true;
                let data = {
                    'action': 'lans_ajax_create_order',
                    'dataType': 'json',
                    'cart': this.$store.state.cart,
                    'cartOrder': this.order,
                    'contact': this.contact,
                    'user': this.$store.state.user,
                    'locale': this.$store.state.locale,
                    'nonce': config.nonce,
                };
                HTTP.post(config.ajaxUrl,
                    Qs.stringify(data)
                ).then(response => {
                    if (response.status === 200) {
                        self.success = self.trans('orderSend');
                        self.isProcessing = false;
                        for (let item in this.$store.state.stock) {
                            if (this.$store.state.stock[item].hasOwnProperty('cartQty')) {
                                this.$store.state.stock[item].qty = this.$store.state.stock[item].qty - this.$store.state.stock[item].cartQty;
                                this.$store.state.stock[item].cartQty = null;
                            }
                        }
                        self.$store.state.cart = [];
                    } else {
                        self.responseError = response.data.data;
                        self.isProcessing = false;
                    }
                }).catch(e => {
                    self.errors.push(e);
                    self.isProcessing = false;
                });
            },
        }
    }
</script>

<style scoped>

    .clear:after {
        content: "";
        display: table;
        clear: both;
    }

    .delivery-week input {
        width: 50px;
        float: left;
    }

    .delivery-week label {
        float: left;
        margin-right: 10px;
    }

    sup, label > sup {
        color: red;
    }

    .btn-submit {
        min-width: 200px;
        text-align: center;
        display: inline-block;
    }
</style>